import React from 'react';

import {Label, Input} from 'Components/Form';

/*
Example...
<EmergencyContactDetails
    value={form.emergency_contact_details}
    error={getFieldError('emergency_contact_details')}
    onChange={(v) => handleInput('emergency_contact_details', v)}
/>
*/

export default class EmergencyContactDetails extends React.Component {
    /**
     * @method handleChange
     * @param {string} key
     * @param {string} v
     */
    handleChange = (key, v) =>  {
        const {value, onChange} = this.props;

        onChange({
            ...value,
            [key]: v
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            value,
            error,
            me
        } = this.props;

        return (
            <div className='flex flex-col gap-4'>
                <p className="font-bold">
                    Emergency Contact Details
                </p>

                {error &&
                    <Label
                        label=""
                        error={error}
                    />
                }

                <Input
                    label="Contact N&#8204;ame"
                    value={value?.name}
                    onChange={(v) => this.handleChange('name', v)}
                />

                <Input
                    label="Relationship"
                    value={value?.relationship}
                    onChange={(v) => this.handleChange('relationship', v)}
                />

                <Input
                    label="Contact Number"
                    value={value?.contact_number}
                    onChange={(v) => this.handleChange('contact_number', v)}
                />
            </div>
        );
    }
}
